import React, { useEffect } from "react";
import { Alert } from "@thecb/components";
import { clearPOSAlerts, deletePOSAlert } from "../../state/root";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";
import { Alert as AlertType, ReduxStoreRoot } from "../../types";

type AlertBarContainerProps = {
  position: string;
};

const AlertBarContainer = styled.div<AlertBarContainerProps>`
  position: ${({ position }) => position};
  display: flex;
  flex-direction: column;
  max-width: 73rem;
  width: 100%;
  z-index: 99;
`;

const AlertBarWrapper = styled.div`
  max-width: 75rem;
  width: 100%;
  margin: 0 0 1rem;
`;

interface Props {
  isToast: boolean;
  alertClearTimeout?: number;
  showQuitLink: boolean;
}
export const POSAlertBar = ({
  isToast = false,
  alertClearTimeout,
  showQuitLink,
}: Props) => {
  const dispatch = useDispatch();
  const { alerts: posAlerts } = useSelector(
    (state: ReduxStoreRoot) => state.posConfigTool.alerts
  );
  useEffect(() => {
    if (alertClearTimeout) {
      const timeoutId = setTimeout(() => {
        if (posAlerts.length) {
          dispatch(clearPOSAlerts());
        }
      }, alertClearTimeout);
      return () => clearTimeout(timeoutId);
    }
  }, [alertClearTimeout, dispatch, posAlerts.length]);

  useEffect(() => {
    const alertsWithTimeouts = posAlerts.filter((a) => a.alertClearTimeout);
    alertsWithTimeouts.forEach((a) =>
      setTimeout(() => {
        dispatch(deletePOSAlert(a.index));
      }, a.alertClearTimeout)
    );
  }, [dispatch, posAlerts, posAlerts.length]);
  return (
    <AlertBarWrapper>
      <AlertBarContainer position={isToast ? "absolute" : "static"}>
        {posAlerts.map((alert: AlertType, i: number) => (
          <Alert
            showQuitLink={showQuitLink}
            key={`${alert.heading}-${alert.index}`}
            onLinkClick={() => dispatch(deletePOSAlert(i))}
            {...alert}
          />
        ))}
      </AlertBarContainer>
    </AlertBarWrapper>
  );
};

export default POSAlertBar;
